import type { VFC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { ManufacturersList } from './Content';

export const ManufacturersListRouter: VFC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <ManufacturersList />
      </Route>
    </Switch>
  );
};
